import { global_hooks } from 'src/globals';

import './news_carousel.scss';

// Turn the news-post listing into a carousel on mobile only (<= 767px).
//
// Rather than duplicate Swiper logic, this hooks the listing into the shared
// `components/carousel_mobile` system: it just tags the container with the
// `ff_swiper_mobile` class + settings. That component then wraps the items,
// inits Swiper at <= 767px and destroys it again above that breakpoint
// (and keeps it in sync on resize).
//
// Runs on `before_init` so the class is in place before
// `components/carousel_mobile/init` checks for `.ff_swiper_mobile` during the
// `init` phase.

const selector = '.ff-news-post .ff_query';

const swiper_mobile_settings = {
	// Match only DIRECT children of `.ff_query`. The shared carousel_mobile
	// can run its init twice (its `swiper/ready` queue re-fires when another
	// module registers late), which would add a second `swiper_mobile_nav`.
	// After the first run the items are wrapped in `.swiper-slide`, so a
	// duplicate pass finds 0 direct-child items and bails out before building
	// another nav. The first init + the resize activate/deactivate cycle
	// (which reuses the items captured on that first pass) are unaffected.
	item_selector: ':scope > .item', // each <a class="item item_blog"> becomes a slide
	activate_screen: 767, // mobile only, 767px and below
	arrows: true,
	bullets: false,
};

global_hooks.on('before_init', init);

function init() {
	document.querySelectorAll(selector).forEach((el) => {
		el.classList.add('ff_swiper_mobile');

		if (!el.dataset.swiper_mobile_settings) {
			el.dataset.swiper_mobile_settings =
				JSON.stringify(swiper_mobile_settings);
		}
	});
}
